module.exports = __webpack_public_path__ + "img/02.eb69beda.png";